import React from "react";

const EasterEgg = () => {
  return (
    <div className="home">
      <p>Wohoo! You found an Easter Egg</p>
    </div>
  );
};

export default EasterEgg;
